var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA2Contact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 36h22v4H7v-4zm38.41 0l-14.2 14.61 2.87 2.79L47.1 40H69v-4H45.41z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/A2_Contact.b1949a07.svg";
export { SvgA2Contact as ReactComponent };